const STEPS = [
  'tumen',
  'cheboksary_second',
  'voronezh_tula',
  'moscow',
  'nizhny',
  'krasnodar',
  'end',
];

class History {
  constructor(node) {
    this.node = node;
    this.$cards = node.querySelectorAll('.js-history-card');
    this.$taggedCards = node.querySelectorAll('.js-history-card[data-tag]');
    this.$activeCard = node.querySelector('.js-history-card:first-child');

    $(this.$activeCard).addClass('history-card--active');

    this.handleScroll = this.handleScroll.bind(this);

    this.timeout = null;
    this.scrollStarted = false;

    window.addEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    // perfomance optimization
    if (this.timeout) {
      window.cancelAnimationFrame(this.timeout);
    }

    if (!this.scrollStarted) {
      $('.js-history-map').addClass('--scrolled');

      this.scrollStarted = true;
    }

    this.timeout = window.requestAnimationFrame((event) => {
      const windowPositionTop = $(window).scrollTop();

      for (let i = 0; i < this.$cards.length; i = i + 1) {
        const $card = this.$cards[i];

        const positionTop = $($card).position().top - 100;

        // if last item scrolled
        if (
          windowPositionTop >= positionTop &&
          i === (this.$cards.length - 1)
        ) {
          this.$activeCard = this.$cards[i];
        // if scrolled item
        } else if (
          windowPositionTop < positionTop &&
          i > 0
        ) {
          this.$activeCard = this.$cards[i - 1];
        }
        
        if (
          (
            windowPositionTop >= positionTop &&
            i === (this.$cards.length - 1)
          ) || (
            windowPositionTop < positionTop &&
            i > 0
          )
        ) {
          $(this.$activeCard).addClass('history-card--active');

          if ($card.dataset.tag) {
            const index = STEPS.indexOf($card.dataset.tag);
            console.log($card.dataset.tag, index);

            if (index !== -1) {
              const activeSteps = STEPS.slice(0, index + 1);
              const inactiveSteps = STEPS.slice(index + 1);

              activeSteps.forEach((step) => {
                $(`.js-history-map-${step}`).addClass('--visible');
              });
              inactiveSteps.forEach((step) => {
                $(`.js-history-map-${step}`).removeClass('--visible');
              });
            } else {
              STEPS.forEach((step) => {
                $(`.js-history-map-${step}`).removeClass('--visible');
              });
            }
          }

          break;
        }
      }

      $(this.$cards).not(this.$activeCard).removeClass('history-card--active');
    });
  }
}

export default () => {
  const node = document.querySelector('.js-history');

  if (!node) {
    return;
  }

  window.historyCards = new History(node);
}



// WEBPACK FOOTER //
// ./assets/scripts/components/history.js